var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyShapeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02891 11.6662C6.95451 11.3778 6.80419 11.1146 6.59359 10.904C6.38299 10.6934 6.1198 10.5431 5.83141 10.4687L0.718912 9.15039C0.631687 9.12563 0.554919 9.0731 0.500255 9.00076C0.445591 8.92842 0.416016 8.84023 0.416016 8.74956C0.416016 8.65889 0.445591 8.57069 0.500255 8.49835C0.554919 8.42601 0.631687 8.37348 0.718912 8.34872L5.83141 7.02956C6.1197 6.95523 6.38282 6.80503 6.59341 6.59459C6.80401 6.38414 6.95438 6.12113 7.02891 5.83289L8.34724 0.72039C8.37175 0.632822 8.42423 0.555675 8.49668 0.500719C8.56913 0.445763 8.65756 0.416016 8.74849 0.416016C8.83943 0.416016 8.92786 0.445763 9.00031 0.500719C9.07276 0.555675 9.12524 0.632822 9.14974 0.72039L10.4672 5.83289C10.5416 6.12128 10.692 6.38447 10.9026 6.59507C11.1132 6.80567 11.3764 6.95599 11.6647 7.03039L16.7772 8.34789C16.8652 8.37214 16.9427 8.42456 16.9979 8.49712C17.0532 8.56968 17.0831 8.65836 17.0831 8.74956C17.0831 8.84075 17.0532 8.92944 16.9979 9.00199C16.9427 9.07455 16.8652 9.12697 16.7772 9.15122L11.6647 10.4687C11.3764 10.5431 11.1132 10.6934 10.9026 10.904C10.692 11.1146 10.5416 11.3778 10.4672 11.6662L9.14891 16.7787C9.1244 16.8663 9.07192 16.9434 8.99948 16.9984C8.92703 17.0533 8.83859 17.0831 8.74766 17.0831C8.65673 17.0831 8.56829 17.0533 8.49585 16.9984C8.4234 16.9434 8.37092 16.8663 8.34641 16.7787L7.02891 11.6662Z",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyShapeIcon);
export default __webpack_public_path__ + "static/media/body-shape-icon.3e6fbdb9c9c1a366d14c86083d7054f7.svg";
export { ForwardRef as ReactComponent };